module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-map-popup\">\n	<div class=\"title\">ID трекера: ")
    ; __append(escapeFn( data.trackerid ))
    ; __append("</div>\n\n	<div class=\"row\">\n		<div><b>Время:</b></div>\n		<ul>\n			<li>Сервер: ")
    ; __append(escapeFn( Date.fromPG(data.createddatetime).format() ))
    ; __append("</li>\n			<li>Трекер: ")
    ; __append(escapeFn( Date.fromTZ(data.datetime).format() ))
    ; __append("</li>\n		</ul>\n	</div>\n\n	<div class=\"row\">\n		<div><b>Геоданные:</b></div>\n		<ul>\n			<li>Широта: ")
    ; __append(escapeFn( GIS.dmsString(data.lat) ))
    ; __append("</li>\n			<li>Долгота: ")
    ; __append(escapeFn( GIS.dmsString(data.lon) ))
    ; __append("</li>\n			<li>Курс: ")
    ; __append(escapeFn( data.course ))
    ; __append("</li>\n		</ul>\n	</div>\n\n	<div class=\"row\">\n		<div><b>Движение:</b></div>\n		")
    ; 
		var run = data.run ? Math.round(data.run) : 0;
		var duration = data.duration ? data.duration: 0;
		
    ; __append("\n		<ul>\n			<li>Пробег:</b> ")
    ; __append(escapeFn( run ))
    ; __append(" м</li>\n			<li>Скорость:</b> ")
    ; __append(escapeFn( data.speed ))
    ; __append(" км/ч</li>\n			<li>Продолжительность:</b> ")
    ; __append(escapeFn( duration ))
    ; __append(" с</li>\n		</ul>\n	</div>\n\n	<div class=\"row\">\n		<div><b>Спутники:</b></div>\n		<ul>\n			<li>ГЛОНАСС: ")
    ; __append(escapeFn( data.satsglonass))
    ; __append("</li>\n			<li>GPS: ")
    ; __append(escapeFn( data.satsgps ))
    ; __append("</li>\n		</ul>\n	</div>\n</div>")
  }
  return __output.join("");

}